import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/managed-entities/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { managedEntitiesBaseQuery } from './baseQuery';

export const MANAGED_ENTITIES_API_REDUCER_PATH =
  'api/managed-entities' as const;

export const managedEntitiesApiRoot = createApi({
  reducerPath: MANAGED_ENTITIES_API_REDUCER_PATH,
  baseQuery: managedEntitiesBaseQuery,
  keepUnusedDataFor: 5 * 60,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
